import AbstractAuthorizationProvider from './AbstractAuthorizationProvider';

export const LoginEvent = Object.freeze({
	LOGIN: 'szn.oauth.signedin',
	LOGOUT: 'szn.oauth.signedout'
});

export default class OauthProvider extends AbstractAuthorizationProvider {
	constructor() {
		super();

		const instance = this;
		this.isReady = false;
		this.token = null;

		this.tokenRequest(token => {
			this.token = token;
			this.isReady = true;
		});

		function onLogin() {
			instance.tokenRequest(token => {
				instance.token = token;
				if (typeof instance.onStateChange === 'function') {
					instance.onStateChange();
				}
			});
		}

		function onLogout() {
			instance.token = null;
			if (typeof instance.onStateChange === 'function') {
				instance.onStateChange();
			}
		}

		window.addEventListener(LoginEvent.LOGIN, onLogin);
		window.addEventListener(LoginEvent.LOGOUT, onLogout);
	}

	isSignedIn() {
		return !!this.token;
	}

	getLogoutData() {
		return { oauthLogout: true };
	}

	async getAuthorizationToken(callback) {
		callback(undefined, this.token);
	}

	/**
	 * get social token from api
	 * window.SznOauthTokenProvider.getAuthorizationToken(callback: (token: null | string) => void): void
	 * @param callback
	 */
	tokenRequest(callback) {
		try {
			window.SznOauthTokenProvider.getAuthorizationToken(callback);
		} catch (error) {
			console.error('failed to get oauth authorization token', error);
			callback(null);
		}
	}
}
